import { render, staticRenderFns } from "./DashboardUser.vue?vue&type=template&id=6c561842"
import script from "./DashboardUser.vue?vue&type=script&lang=js"
export * from "./DashboardUser.vue?vue&type=script&lang=js"
import style0 from "./DashboardUser.vue?vue&type=style&index=0&id=6c561842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports